<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import {fade} from 'svelte/transition';
    import Select from 'svelte-select';
    import axios from "axios";

    class PageInfo {
        constructor({page=1, perPageNum=20, totalCount=100}) {
            this.totalCount = totalCount;
			this.perPageNum = perPageNum;
            this.setPage(page, perPageNum); 
        }

        setPage(page=1) {
            this.page = page;
            this.showPage = 10;
            this.pageStartNum = (page - 1) * this.perPageNum;
            this.endPage = Math.ceil(page / this.showPage) * this.showPage;
            this.startPage = this.endPage - this.showPage + 1;
            let tempEndPage = Math.ceil(this.totalCount / this.perPageNum);
            if ( this.endPage > tempEndPage) {
                this.endPage = tempEndPage;
            }
            this.prev = this.startPage != 1;
            this.next = this.endPage * this.perPageNum < this.totalCount; 
            this.pageList=[]; 
            for (let i = this.startPage; i <= this.endPage; i++) { 
                this.pageList.push(i);
            }
        }

        getListNumber(index) {
            return (this.page - 1) * this.perPageNum + index;
        }
        clickPrev() {
            this.setPage(this.page - 1);
            getChatList();
        }
        clickNext() {
            this.setPage(this.page + 1);
            getChatList();
        }
        clickPage(page) {
            this.setPage(page);
            getChatList();
        }
        clickSearch() {
            this.setPage();
            getChatList();
        }
        enter(e) {
            if (e.key === "Enter") {
                this.clickSearch();
            }
        }
    }

    let chatList = [];
    let options = { year: "numeric", month: "long", day: "numeric" };
	let categoryList = [];
    let searchText = '';
    let searchCondition;
    let isPhoneNoPopup = false;
    let pageInfo = new PageInfo({"perPageNum":10});
    let viewPhoneNo;
    let viewEmail;
    let viewName;
	let currentTab = "characterManage";
	let currentSubTab = "defaultManage-image";
    
    const getChatList = (e) => {
        PRConnect.send("/api/Admin/getChatList", {...pageInfo, searchCondition, searchText}, data => {
            if (data.header.status === "success") {
                chatList = data.result.chatList;
                let totalCount = data.result.totalCount;
                pageInfo = new PageInfo({...pageInfo, totalCount});
				categoryList = data.result.categoryList;
            } 
		}, () => { navigateTo("/main"); });
    }

    const goToUserLogin = (chat) => {
        PRConnect.send("/api/Admin/setUserLogin", {userId :chat.userId}, data => {
            if (data.header.status === "success") {
                window.open(`/chat-builder/${chat.id}`, "_blank");
            }
        });
    }

    const clickPhoneNo = (user) => {
        isPhoneNoPopup = true;
        viewEmail = user.emailId;
        viewPhoneNo = user.phoneNo;
        viewName = user.name;
    }

    onMount(() => {
        getChatList();
    });

	const clickBlank = (pageUrl) => {
		window.open(pageUrl, "_blank");
	}

	const changeChatCategory = (chat) => {
		PRConnect.send("/api/Admin/modifyChatCategory", {chatId : chat.id, categoryId : chat.categoryId}, data => {
            if (data.header.status === "success") {
                console.log("category update");
            }
        });
	}

	const clickChangeOpenFlag = (chat) => {
		chat.aiHomeOpenFlag = chat.aiHomeOpenFlag === "Y" ? "N" : "Y";
		chatList = [...chatList];
		PRConnect.send("/api/Admin/modifyChatOpenFlag", {chatId : chat.id, aiHomeOpenFlag : chat.aiHomeOpenFlag}, data => {
            if (data.header.status === "success") {
                console.log("aiHomeOpenFlag update");
            }
        });
	}
	
</script>

<div class="container home" in:fade>
	
	<div class="w-tab-content" in:fade>
		<div class="tabs-menu-4 w-tab-menu">
			<a data-w-tab="Tab 1" class="tab-link-tab-1-4 w-inline-block w-tab-link" class:w--current={currentTab == "defaultManage"} on:click={()=> currentTab = "defaultManage"}>
				<div class="text-block-139">기본설정 관리</div>
			</a>
			<a data-w-tab="Tab 2" class="tab-link-tab-1-4 w-inline-block w-tab-link" class:w--current={currentTab == "mainCategoryManage"} on:click={()=> currentTab = "mainCategoryManage"}>
				<div class="text-block-139">카테고리 관리</div>
			</a>
			<a data-w-tab="Tab 3" class="tab-link-tab-2-4 w-inline-block w-tab-link" class:w--current={currentTab == "characterManage"} on:click={()=> currentTab = "characterManage"}>
				<div class="text-block-140">AI챗 관리</div>
			</a>
		</div>
		<div data-w-tab="Tab 1" class="w-tab-pane" class:w--tab-active={currentTab == "defaultManage"}>
			<div class="tabs-menu-4 w-tab-menu">
				<a data-w-tab="Tab 1" class="tab-link-tab-1-4 w-inline-block w-tab-link" class:w--current={currentSubTab == "defaultManage-conversation"} on:click={()=> currentSubTab = "defaultManage-conversation"}>
					<div class="text-block-139">대화프롬프트</div>
				</a>
				<a data-w-tab="Tab 1" class="tab-link-tab-1-4 w-inline-block w-tab-link" class:w--current={currentSubTab == "defaultManage-image"} on:click={()=> currentSubTab = "defaultManage-image"}>
					<div class="text-block-139">이미지프롬프트</div>
				</a>
			</div>
			<div data-w-tab="Tab 1" class="w-tab-pane" class:w--tab-active={currentSubTab == "defaultManage-conversation"}>
			</div>
			<div data-w-tab="Tab 2" class="w-tab-pane" class:w--tab-active={currentSubTab == "defaultManage-image"}>
				<div class="image-button-wrapper">
					<div class="profile-image-button">프로필 이미지</div>
					<div class="background-image-button">배경 이미지</div>
					<div class="call-setting-button">마지막 세팅값 불러오기</div>
				</div>
				<div class="image-prompt-wrapper">
					<div class="image-prompt-header">프로필 이미지 프롬프트</div>
					<div class="image-prompt-sub-header">이미지 프롬프트 텍스트 설정</div>
					<div class="image-prompt-context-wrapper">
						<textarea></textarea>
					</div>		
					<div class="image-prompt-sub-header">이미지 키워드 설정</div>
					<div class="image-prompt-keyword-wrapper">
						<div class="imamge-promt-keyword">검정머리</div>
						<div class="imamge-promt-keyword">밝은</div>
					</div>
					<div class="image-prompt-sub-header">생성된 이미지 값 미리보기</div>
					<div class="image-promt-previw-wrapper">
						<div class="image-prompt-create-button">생성하기</div>
						<div class="image-prompt-re-create-button">다시 생성하기</div>
						<div class="image-prompt-preview-image-wrapper">
							<img class="image-prompt-preview-image" src="" />
						</div>
					</div>
					<div class="image-prompt-result-button-wrapper">
						<div class="image-prompt-save-button">이미지 프롬프트 저장하기</div>
						<div class="image-prompt-assign-button">이미지 프롬프트 적용하기</div>
					</div>
					<div class="image-prompt-header">프롬프트 이력</div>
					<div class="image-prompt-history-wrapper">
						<div class="imamge-prompt-th">
							<div class=""></div>
							<div class=""></div>
							<div class=""></div>
						</div>
						<div class="image-prompt">
						</div>
					</div>
				</div>
			</div>
		</div>
		<div data-w-tab="Tab 2" class="w-tab-pane" class:w--tab-active={currentTab == "mainCategoryManage"}>
			<div class="">
			</div>
		</div>
		<div data-w-tab="Tab 3" class="w-tab-pane" class:w--tab-active={currentTab == "characterManage"}>
			<div class="title-wrapper">
				<div class="title-inner">
					<div class="title1">Home</div>
					<div class="title-main">AI챗목록</div>
					<div class="title-sub">아바톡에 생성되어 있는 AI챗 목록입니다.</div>
				</div>
			</div>
			<div class="userList-wrapper">
				<div class="search-wrapper">
					<select bind:value={searchCondition}>
						<option value="chatId" selected>AI챗 아이디</option>
						<option value="title">AI챗 이름</option>
						<option value="userId" selected>사용자 아이디</option>
						<option value="userEmail">사용자 이메일</option>
						<option value="userName">사용자 이름</option>
						<option value="category">카테고리</option>
					</select>
					<input type="text" bind:value={searchText} on:keydown={(e)=> pageInfo.enter(e)}>
					<button on:click={getChatList}>
						검색
					</button>
				</div>
				<div class="table-wrapper">
					<table>
						<tr class="tr-th">
							<th class="no">#</th>
							<th>아이디</th>
							<th class="table-name">이메일</th>
							<th class="table-name">이름</th>
							<th>AI챗아이디</th>
							<th>AI챗</th>
							<th>프로필</th>
							<th class="table-name">AI챗 이름</th>
							<th class="table-name">카테고리</th>
							<th>대화개수</th>
							<th>메인공개여부</th>
							<th>사용자로그인</th>
						</tr>
					{#each chatList as chat, index (index)}
						<tr>
							<td class="no">{pageInfo.getListNumber(index+1)}</td>
							<td>{chat.userId}</td>
							<td>{chat.userEmail}</td>
							<td>{chat.userName}</td>
							<td>{chat.id}</td>
							<td class="pointer" on:click={()=>clickBlank(chat.pageUrl)}>확인하기</td>
							<td><img src={chat.profileImageContent} width="40px" /></td>
							<td>{chat.title || ""}</td>
							<td>
								<select bind:value={chat.categoryId} on:change={()=> changeChatCategory(chat)}>
									{#each categoryList as category}
									<option value={category.id}>{category.name}</option>
									{/each}
								</select>
							</td>
							<td>{chat.freeUsageCount || 0}</td>
							<td >
								<div class="toggle-button _2" on:click={()=>clickChangeOpenFlag(chat)}>
									<div class="toggle" class:on={chat.aiHomeOpenFlag === "Y"}></div>
									<div class="toggle-round" class:on={chat.aiHomeOpenFlag === "Y"}></div>
								</div>
							</td>
							<td class="pointer" on:click={() => goToUserLogin(chat)}>빌더가기</td>
						</tr>
					{/each}
					</table>
				</div>
				<div class="paging-wrapper">
					{#if pageInfo.prev}
					<div class="page-number" on:click={()=> pageInfo.clickPrev()}>◀︎</div>
					{/if}
					{#each pageInfo.pageList as page} 
					<div class="page-number" class:active={pageInfo.page === page} on:click={pageInfo.clickPage(page)}>{page}</div>
					{/each}
					{#if pageInfo.next}
					<div class="page-number" on:click={()=> pageInfo.clickNext()}>▶︎</div>
					{/if}
				</div>
			</div>
		</div>
	</div>
</div>
<div class="ava-popup" class:show={isPhoneNoPopup}>
    <div class="popup-layer withdraw">
        <div class="titile-text popup">
            <div class="h1 margin20">회원 정보</div>
            <div class="title-sub popup">{viewName} / {viewEmail}</div>
            <div class="title-sub popup view-phoneNo">{viewPhoneNo}</div>
        </div>
        <div class="popup-button">
            <a href="#" class="close-button w-button" on:click={()=>isPhoneNoPopup = false}>닫기</a>
        </div>
    </div>
</div>
<style>
    .userList-wrapper {
        margin: 0 auto;
        overflow: auto;
    	height: max-content;
    }
    .active {
        font-weight: bold;
    }
    .page-number {
        cursor: pointer;
        display: inline-block;
        padding: 12px;
    }
	.title-wrapper {
		padding-left: 10px;
		border: 1px solid transparent;
    	background-color: transparent;
	}
    td {
        padding: 12px;
        text-align: center;
    }
    td, th { 
        min-width: 100px;
    }
    .tr-th {
        border-bottom: 2px solid darkgray;
    }

	th.no {
		width: 50px;
	}

	td.no {
		width: 50px;
	}

    .table-email {
        min-width: 300px;
    }
    .table-name {
        min-width: 200px;
    }
    .paging-wrapper {
        display: flex;
        margin: 0 auto;
        width: max-content;
    }

    .search-wrapper {
        margin-bottom: 16px;
    }
    .popup-button {
        margin-top: 20px;
    }
    .view-phoneNo {
        font-size: 20px;
        font-weight: 700;
    }
	
	.toggle.on {
        border-color: #ff558d;
        border-radius: 30px;
        background-color: #ff558d;
    }

    .toggle {
        background-color: #999;
    }

	.container {
		overflow-x: auto;
		align-items: center;
	}
	.title-inner {
		margin-left: 0;
	}
	.w-tab-content {
		min-width: 1600px;
		margin-top: 10px;
	}
	.table-wrapper {
		overflow: scroll;
	}
</style>